import React, { Component } from 'react';
import { options } from './keys';
import { flattenChildren, getParents, updateHrefs } from './helpers';
import { withTranslation } from 'react-i18next';
import { isTrue } from '../../helpers/isTrue';
import { getUpgradeUrl } from '../../helpers/upgradeUrl';

class TopMenu extends Component {
    constructor(props) {
        super();
        this.state = {
            selectedIds: [],
            defaultSelected: [],
        };
    }

    // `default_domain_id` is resolved asynchronously by Layout (from /api/v1/me/), so the
    // domain id must be derived from the current props on every render instead of being
    // frozen at construction time.
    get domainId() {
        return this.props.domain_id || this.props.default_domain_id;
    }

    componentDidMount() {
        this.syncSelectedItem();
    }

    componentDidUpdate(prevProps) {
        const prevDomainId = prevProps.domain_id || prevProps.default_domain_id;
        if (prevDomainId !== this.domainId) this.syncSelectedItem();
    }

    syncSelectedItem() {
        const allOptions = options({
            domainId: this.domainId,
            t: this.props.t,
        });
        const all = flattenChildren(allOptions);
        const selectedItem = all.find((item) => {
            if (item.hrefStartsWith)
                return window.location?.pathname.startsWith(item.hrefStartsWith);

            if (item.pathnames) return item.pathnames.includes(window.location?.pathname);

            return item.href === window.location?.pathname;
        });
        const parents = getParents(all, selectedItem);
        const reversed = parents.reverse();

        if (selectedItem)
            this.setState({
                selectedIds: [...reversed, selectedItem.id],
                defaultSelected: [...reversed, selectedItem.id],
                selectedUrl: selectedItem.id,
            });
    }

    render() {
        let allOptions = options({
            domainId: this.domainId,
            t: this.props.t,
        });

        if (!this.props.show_discover_analytics && !isTrue(window.is_superuser)) {
            allOptions = allOptions.map((option) => {
                if (option.id === 'discover_analytics') {
                    return {
                        ...option,
                        children: updateHrefs(
                            option.children,
                            getUpgradeUrl(
                                '/domains/inactive-subscription?excluded=discover_analytics',
                            ),
                        ),
                    };
                }
                if (option.id === 'opportunities') {
                    return {
                        ...option,
                        children: option.children.map((child) => {
                            if (child.id === 'opportunities_Discover') {
                                return {
                                    ...child,
                                    href: getUpgradeUrl(
                                        '/domains/inactive-subscription?excluded=discover_analytics',
                                    ),
                                };
                            }
                            return child;
                        }),
                    };
                }
                return option;
            });
        }
        if (!this.props.show_gsc_data && !isTrue(window.is_superuser)) {
            allOptions = allOptions.map((option) => {
                if (option.id === 'search_analytics' || option.id === 'tools') {
                    return {
                        ...option,
                        children: updateHrefs(
                            option.children,
                            getUpgradeUrl(
                                '/domains/inactive-subscription?excluded=search_analytics',
                            ),
                        ),
                    };
                }
                if (option.id === 'googleSurfaces') {
                    return {
                        ...option,
                        href: getUpgradeUrl(
                            '/domains/inactive-subscription?excluded=search_analytics',
                        ),
                    };
                }
                if (option.id === 'opportunities') {
                    return {
                        ...option,
                        children: option.children.map((child) => {
                            if (child.id === 'opportunities_SEO_Recommendations') {
                                return {
                                    ...child,
                                    href: getUpgradeUrl(
                                        '/domains/inactive-subscription?excluded=search_analytics',
                                    ),
                                };
                            }
                            return child;
                        }),
                    };
                }
                return option;
            });
        }
        if (!this.props.show_commerce && !isTrue(window.is_superuser)) {
            allOptions = allOptions.map((option) => {
                if (option.id === 'commerce') {
                    return {
                        ...option,
                        href: getUpgradeUrl('/domains/inactive-subscription?excluded=commerce'),
                    };
                }
                return option;
            });
        }
        if (!this.props.show_ai_tracking && !isTrue(window.is_superuser)) {
            allOptions = allOptions.map((option) => {
                if (option.id === 'ai_tracking') {
                    return {
                        ...option,
                        children: updateHrefs(
                            option.children,
                            getUpgradeUrl('/domains/inactive-subscription?excluded=ai_tracking'),
                        ),
                    };
                }
                return option;
            });
        }
        return (
            <>
                <div className={`top-menu ${this.props.showTopBanner ? 'with-top-banner' : ''}`}>
                    <button
                        className="top-menu-responive-btn"
                        onClick={this.props.toggleResponsiveTopMenu}
                    >
                        <i className="icon-menu"></i>
                    </button>
                    <div className="top-menu-left">
                        {allOptions.map(
                            (item) =>
                                !item.isHidden && (
                                    <React.Fragment key={item.id}>
                                        {item.href && (
                                            <a
                                                href={item.href}
                                                className={`top-menu-left-item ${
                                                    this.state.defaultSelected.includes(item.id)
                                                        ? 'active'
                                                        : ''
                                                }`}
                                            >
                                                {item.title}
                                            </a>
                                        )}
                                        {item.collapsTargetId && (
                                            <div className="top-menu-left-item ">
                                                <div
                                                    className={`top-menu-left-item-title with-arrow  ${
                                                        this.state.selectedIds?.includes(item.id)
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                >
                                                    {item.title}
                                                </div>
                                                <div className="top-menu-left-item-dropdown">
                                                    {item.children.map((child) => (
                                                        <React.Fragment key={child.id}>
                                                            <div
                                                                className={`top-menu-child
                                                        ${
                                                            this.state.selectedIds?.includes(
                                                                child.id,
                                                            )
                                                                ? 'active'
                                                                : ''
                                                        }
                                                        ${child.disabled ? 'is-disabled' : ''}
                                                        `}
                                                                key={child.id}
                                                            >
                                                                {child.disabled &&
                                                                    !child.href &&
                                                                    !child.collapsTargetId && (
                                                                        // Not built yet: listed
                                                                        // as plain text until
                                                                        // `keys.js` gives it an
                                                                        // `href`.
                                                                        <a
                                                                            style={{
                                                                                width: '100%',
                                                                            }}
                                                                        >
                                                                            {child.icon && (
                                                                                <i
                                                                                    className={
                                                                                        child.icon
                                                                                    }
                                                                                ></i>
                                                                            )}
                                                                            {child.title}
                                                                        </a>
                                                                    )}
                                                                {child.href && (
                                                                    <a
                                                                        href={child.href}
                                                                        style={{ width: '100%' }}
                                                                    >
                                                                        {child.icon && (
                                                                            <i
                                                                                className={
                                                                                    child.icon
                                                                                }
                                                                            ></i>
                                                                        )}
                                                                        {child.title}
                                                                    </a>
                                                                )}
                                                                {child.collapsTargetId && (
                                                                    <>
                                                                        <div
                                                                            className="w-100 with-arrow"
                                                                            style={{
                                                                                width: '100%',
                                                                            }}
                                                                        >
                                                                            {child.icon && (
                                                                                <i
                                                                                    className={
                                                                                        child.icon
                                                                                    }
                                                                                ></i>
                                                                            )}
                                                                            {child.title}
                                                                        </div>
                                                                        <div className="top-menu-left-item-child-dropdown">
                                                                            {child.children.map(
                                                                                (state) => (
                                                                                    <div
                                                                                        key={
                                                                                            state.id
                                                                                        }
                                                                                        className={`top-menu-child
                                                                                ${
                                                                                    this.state.selectedIds?.includes(
                                                                                        state.id,
                                                                                    )
                                                                                        ? 'active'
                                                                                        : ''
                                                                                }
                                                                                ${
                                                                                    state.disabled
                                                                                        ? 'is-disabled'
                                                                                        : ''
                                                                                }
                                                                                `}
                                                                                    >
                                                                                        <a
                                                                                            href={
                                                                                                state.href
                                                                                            }
                                                                                            style={{
                                                                                                width: '100%',
                                                                                            }}
                                                                                        >
                                                                                            {state.icon && (
                                                                                                <i
                                                                                                    className={
                                                                                                        state.icon
                                                                                                    }
                                                                                                ></i>
                                                                                            )}
                                                                                            {
                                                                                                state.title
                                                                                            }
                                                                                        </a>
                                                                                    </div>
                                                                                ),
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </React.Fragment>
                                ),
                        )}
                    </div>
                    <div className="top-menu-right">
                        <button
                            className="btn-icon"
                            onClick={() => this.props.updateStyle('menu-version')}
                        >
                            <i className="icon-u_left-arrow-to-left-path2" />
                        </button>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(TopMenu);
